module.exports = __webpack_public_path__ + "static/media/project1.7464f1de.jpg";